module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_b/aoj_b-3-4dcd9ea72a581fbe8edbb3378ba28575.jpg";